document.getElementById('otherCountryForm').addEventListener('submit', function(event) {
    event.preventDefault();

   
    const formData = {
        firstName: document.getElementById('firstName').value,
        lastName: document.getElementById('lastName').value,
        email: document.getElementById('email').value,
        country: document.getElementById('country').value,
    };

   
    const mailchimpEndpoint = 'https://us19.api.mailchimp.com/3.0/lists/9c87604653/members';
    const apiKey = 'your_mailchimp_api_key';

    
    fetch(mailchimpEndpoint, {
        method: 'POST',
        headers: {
            'Authorization': `apikey d4cf4950cfac40eba03636bc2c38e1b2-us19`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email_address: formData.email,
            status: 'subscribed',
            merge_fields: {
                FNAME: formData.firstName,
                LNAME: formData.lastName,
                COUNTRY: formData.country,
            },
        }),
    })
    .then(response => response.json())
    .then(data => {
        console.log('Successfully added to Mailchimp:', data);
        alert('Thank you for subscribing!');
    })
    .catch((error) => {
        console.error('Error:', error);
        alert('Something went wrong. Please try again.');
    });
});